module.exports = __webpack_public_path__ + "img/logo.41aa7c95.png";